"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
class ExternalLink {
    constructor(links) {
        if (links) {
            this.links = links;
        }
    }
    checkLinks(extraClass) {
        var _a;
        (_a = this.links) === null || _a === void 0 ? void 0 : _a.forEach((link) => {
            const isExternal = this.isExternal(link);
            if (isExternal) {
                this.insertIcon(link, extraClass);
            }
        });
    }
    isExternal(link) {
        try {
            const href = link.getAttribute('href');
            const isVideoButton = link.classList.contains('play-video-button');
            const isEmailLink = href.indexOf('mailto:') > -1;
            const isPhoneLink = href.indexOf('tel:') > -1;
            const isScriptLink = href.indexOf('javascript:') > -1;
            if (!href || isVideoButton || isEmailLink || isPhoneLink || isScriptLink) {
                return false;
            }
            return new URL(href).origin !== location.origin;
        }
        catch (e) {
            return false;
        }
    }
    insertIcon(element, extraClass = '') {
        const iconElement = MosaicIcon_1.MosaicIconFactory.createIcon('open-in-new', `inline-block ml-1 ${extraClass}`);
        element.appendChild(iconElement);
    }
}
exports.ExternalLink = ExternalLink;
